<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('globalloyaltysettings') }}</div>
      <div>
        <router-link
          class="btn-blue"
          :to="'edit-global-loyalty-settings?ls_id=' + ls_id"
        >{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="global-loyalty-settings"
        >{{ $t('globalloyaltysettings') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div
            class="col-md-3 col-lg-3 col-xl-3 d-flex flex-column"
          >
          <b>{{ $t('global') }} {{ $t('loyaltysettings') }} {{ $t('name') }}</b>
          <span class="">{{ loyalty_settings.ls_name }}</span>
          </div>
          <!--div class="col-md-9 col-lg-10 col-xl-10">
            <span class="mr-3"></span>
            <span class="mr-3">{{ loyalty_settings.ls_name }}</span>
          </div-->

          <div class="col-md-3 col-lg-3 col-xl-2 d-flex flex-column">
            <b>{{ $t('expiry') }} {{ $t('rule') }}</b>
            <span class="">{{ loyalty_settings.expiry_rule }}</span>
          </div>

        <div class="col-md-2 col-lg-2 col-xl-2 d-flex flex-column">
            <b>{{ $t("expiry") }} {{ $t('value') }}</b>

            <span class="">{{ loyalty_settings.expiry_value }}</span>
          </div>

          <div class="col-md-2 col-lg-2 col-xl-2 d-flex flex-column">
            <b>{{ $t("initialamount") }}</b>

            <span class="">{{ loyalty_settings.lnitial_load }}</span>
          </div>

           <div
            class="col-md-3 col-lg-3 col-xl-3 d-flex flex-column"
          >
          <b>{{ $t("globalloyaltysettings") }} {{ $tc('status', 1) }}</b>
           <span style="color:green" v-if="loyalty_settings.ls_is_active == 'Y'" class="">
             <b>{{ $t('active') }}</b>
             </span>
             <span v-else class="fb_bold" style="color:red">{{ $t('inactive') }}</span>
          </div>


        </div>
      </div>
     

    

      <div class="col-md-12 py-3 px-0">
        <table class="table table-sm mb-0">
          <thead>
            <tr class="dark_back">
              <th scope="col">{{ $t('global') }} {{ $t('loyaltysettings') }} {{ $t('level') }}</th>
              <th scope="col">{{ $t('pointsrequired') }}</th>
              <th scope="col">{{ $t('bonuspoints') }}</th>
              <th scope="col">{{ $t('active') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(levellist, levellistIndex) in loyalty_levels" :key="levellistIndex" class="light_grey_back">
              <td>{{ levellist.ll_name }}</td>
              <td>{{ levellist.points_required }}</td>
              <td>{{ levellist.bonus_points }}</td>
              <td v-if="levellist.ll_is_active == true">{{ $t('yes') }}</td>
              <td v-else>{{ $t('no') }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    

      <div class="col-md-12 py-1 border-bottom">
        <div class="row">
          <div class="col-md-3 col-lg-3 col-xl-3 d-flex flex-column">
            <b>{{ $t('createdat') }}</b>
            <span class="">{{ loyalty_settings.created_at | dateparse }}</span>
          </div>
        

           <div class="col-md-3 col-lg-3 col-xl-3 d-flex flex-column">
            <b>{{ $t('createdby') }}</b>
            <span
              v-if="loyalty_settings.created_by && loyalty_settings.created_by.length > 0"
              class=""
            >{{ loyalty_settings.created_by }}</span>
            <span v-else class="">-</span>
            </div>

             <div class="col-md-3 col-lg-3 col-xl-3 d-flex flex-column">
            <b>{{ $t('modifiedat') }}</b>
            <span class="" v-if="login_user_role_id === 1 ">{{ loyalty_settings.updated_at | dateparse }}</span>
            </div>

             <div class="col-md-3 col-lg-3 col-xl-3 d-flex flex-column">
            <b>{{ $t('modifiedby') }}</b>
            <span class="" v-if="login_user_role_id === 1 ">{{ loyalty_settings.updated_by }}</span>
          </div>

        </div>
      </div>
   
     
   
    </div>
  </div>
</template>


<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      ls_id: null,
      login_user_role_id: null,
      loyalty_settings: [],
      loyalty_levels: []
    };
  },
  beforeMount() {
    const { ls_id } = this.$route.query;
    this.ls_id = ls_id;
    this.getGloballoyaltysettingsBYID(ls_id);
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  methods: {
    getGloballoyaltysettingsBYID: function(id) {
      let payload = {
        ls_id: id
      };
      MarketingService.GetGlobalLoyaltySettingsBYID(payload).then(response => {
        const { data } = response;

        if (data.status) {
          this.loyalty_settings = data.loyalty_settings;
          this.getViewUsersDetails(this.loyalty_settings.created_by,'created_by');

          this.getViewUsersDetails(this.loyalty_settings.updated_by,'updated_by');
          this.loyalty_levels = data.loyalty_levels;
        }
      });
    },

    getViewUsersDetails(user_id, fieldvalue, key) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.loyalty_settings[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch(this._CatchError); //message
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/GlobalLoyaltySettingsComponents/viewgloballoyaltysettings.vue